module.exports = __webpack_public_path__ + "static/media/pla_no_pas.a4468480.png";